import commonApi from '@/api/api.common'
import dayjs from 'dayjs'
import i18n from '@/locales/index'
export default [
  {
    type: 'datepicker',
    placeholder: '',
    filed: 'daterange',
    label: '',
    startplh: i18n.t('Device.warningReportStateTime'),
    endplh: i18n.t('Device.warningReportEndTime'),
    // pickerType: 'datetimerange',
    // valueFormat: 'yyyy-MM-dd',
    format: 'yyyy-MM-dd',
    default: [
      dayjs()
        .startOf('month')
        .format('YYYY-MM-DD'),
      dayjs().format('YYYY-MM-DD')
    ]
  }
  // {
  //   type: 'select',
  //   placeholder: '故障状态',
  //   filed: 'state',
  //   default: '',
  //   query: commonApi.device_fault_type_select
  // }
]
